import { useContext, useState } from "react";
import { Accordion } from "react-bootstrap";
import { useAccordionButton } from "react-bootstrap/AccordionButton";
import AccordionContext from "react-bootstrap/AccordionContext";

const KYouthFaqCategories = [
  {
    id: 1,
    slug: "about-k-youth",
    label: "About Programme",
  },
  {
    id: 2,
    slug: "about-the-course",
    label: "Course Structure",
  },
  {
    id: 3,
    slug: "about-the-on-the-job-training",
    label: "OJT Experience",
  },
];

const aboutKYouth = {
  leftColumn: [
    {
      id: 1,
      title: "What is the K-Youth Development Programme 2026?",
      body: "K-Youth Development Programme is a youth employability initiative by Khazanah Nasional Berhad aimed at developing Malaysia’s future talents through industry-relevant skills and experience.",
    },
    {
      id: 2,
      title: "What are the requirements?",
      body: (
        <div>
          <ul>
            <li>Malaysian citizen aged 18-30</li>
            <li>Currently unemployed</li>
            <li>Diploma or Degree holder</li>
            <li>
              Not participated in similar government programmes (MySTEP,
              PROTÉGÉ, etc.)
            </li>
            <li>Able to commit full-time for 4 months</li>
            <li>Strong interest in Digital & Technology roles</li>
          </ul>
        </div>
      ),
    },
    {
      id: 3,
      title: "What is the cost of the programme?",
      body: "There is no cost. Participants will receive a monthly allowance of approximately RM2,000.",
    },
    {
      id: 4,
      title: "What is the programme structure?",
      body: "The programme runs for 4 months: 1 month of training followed by 3 months of On-the-Job Training (OJT). Training is hybrid, while OJT is fully physical.",
    },
  ],
  rightColumn: [
    {
      id: 1,
      title: "Will I receive a certificate?",
      body: "Yes, participants will receive industry-recognised certificates upon successful completion.",
    },
    {
      id: 2,
      title: "When will I receive my offer/placement letter?",
      body: "It will be issued after final approval. Further details will be included in your offer letter.",
    },
    {
      id: 3,
      title: "Are host companies under Pepper Labs?",
      body: "No, host companies are external. If a company is not listed, they will need to register under the programme to participate",
    },
    {
      id: 4,
      title: "Are there placements outside Klang Valley?",
      body: "Yes, we do offer opportunities outside Klang Valley",
    },
  ],
};

const aboutTheCourse = {
  leftColumn: [
    {
      id: 1,
      title: "What is the course structure?",
      body: "The programme focuses on Artificial Intelligence (AI) training with placement opportunities, allowing participants to apply AI solutions in real-world business environments.",
    },
    {
      id: 2,
      title: "When can I register for this programme?",
      body: "Registration is currently open. Training is expected to begin in April 2026.",
    },
    {
      id: 3,
      title: "What will I learn in this programme?",
      body: (
        <div>
          <div>
            <b>Technical Skills:</b>
          </div>
          <ul>
            <li>AI Certifications (Microsoft, Google, AWS)</li>
          </ul>
          <b>Professional Skills:</b>
          <ul>
            <li>Resume Writing & Interview Skills</li>
            <li>Communication & Presentation Skills</li>
          </ul>
          <b>Future Skills:</b>
          <ul>
            <li>ESG & Green Skills</li>
            <li>Cybersecurity</li>
          </ul>

          <b>Leadership:</b>

          <ul>
            <li>Corporate Leadership</li>
            <li>Public Policy Awareness</li>
          </ul>
        </div>
      ),
    },
  ],
  rightColumn: [
    {
      id: 1,
      title: "What is the mode of learning?",
      body: "The programme uses hybrid learning including physical classes, virtual sessions, webinars, mentorship, and self-paced learning modules.",
    },
    {
      id: 2,
      title: "What happens if I get a job during the programme?",
      body: "You are encouraged to pursue job opportunities. If you secure a permanent role, the programme will assist your transition.",
    },
    {
      id: 3,
      title: "Is placement onsite or remote?",
      body: "The majority of positions require on-site attendance, subject to the host company.",
    },
    {
      id: 4,
      title: "How much is the penalty fee?",
      body: "The withdrawal fee varies case by case, based on incurred course fees and salaries disbursed.",
    },
  ],
};

const aboutTheOTJTrainig = {
  leftColumn: [
    {
      id: 1,
      title: "What is On-the-Job Training (OJT)?",
      body: "OJT is a minimum 15-week paid placement where participants gain real workplace experience and apply their knowledge.",
    },
    {
      id: 2,
      title: "Will I get a job after the programme?",
      body: "Employment depends on your performance and company hiring needs, but strong performance increases your chances.",
    },
  ],
  rightColumn: [
    {
      id: 1,
      title: "Is accommodation provided during OJT?",
      body: "No, accommodation is not provided. However, some companies may offer arrangements during interviews.",
    },
    {
      id: 2,
      title: "Where is the physical class & OJT location?",
      body: "Classroom sessions are held in Petaling Jaya. OJT details will be shared with successful candidates only.",
    },
  ],
};

const CustomToggle = ({ children, eventKey }) => {
  const { activeEventKey } = useContext(AccordionContext);
  const decoratedOnClick = useAccordionButton(eventKey);
  const isCurrentEventKey = activeEventKey === eventKey;
  return (
    <button
      type="button"
      onClick={decoratedOnClick}
      aria-expanded={isCurrentEventKey ? true : false}
      className="edu-accordion-button"
    >
      {children}
    </button>
  );
};

const KYouthFaq = ({ wrapperClass }) => {
  const [selectedItem, setSelectedItem] = useState("about-k-youth");
  const [activeId1, setActiveId1] = useState("0");
  const [activeId2, setActiveId2] = useState("0");
  const [activeId3, setActiveId3] = useState("0");
  const [activeId4, setActiveId4] = useState("0");
  const [activeId5, setActiveId5] = useState("0");
  const [activeId6, setActiveId6] = useState("0");

  function toggleActive1(id) {
    if (activeId1 === id) {
      setActiveId1(null);
    } else {
      setActiveId1(id);
    }
  }
  function toggleActive2(id) {
    if (activeId2 === id) {
      setActiveId2(null);
    } else {
      setActiveId2(id);
    }
  }
  function toggleActive3(id) {
    if (activeId3 === id) {
      setActiveId3(null);
    } else {
      setActiveId3(id);
    }
  }
  function toggleActive4(id) {
    if (activeId4 === id) {
      setActiveId4(null);
    } else {
      setActiveId4(id);
    }
  }
  function toggleActive5(id) {
    if (activeId5 === id) {
      setActiveId5(null);
    } else {
      setActiveId5(id);
    }
  }
  function toggleActive6(id) {
    if (activeId6 === id) {
      setActiveId6(null);
    } else {
      setActiveId6(id);
    }
  }

  return (
    <div
      id="faq"
      style={{
        scrollMarginBlockStart: 80,
      }}
      className={`edu-accordion-area accordion-shape-1 edu-section-gap bg-color-white ${
        wrapperClass ? wrapperClass : ""
      } `}
    >
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="section-title text-center">
              <span className="pre-title">FAQ Questions</span>
              <h3 className="title">
                Get Every General Answers <br /> From Here
              </h3>
            </div>
          </div>
        </div>

        <div className="row">
          <div className="col-lg-12">
            <ul className="edu-tab-nav nav nav-tabs mt--40">
              {KYouthFaqCategories.map((button) => (
                <li className="nav-item" key={button.id}>
                  <button
                    className={
                      button.slug === selectedItem
                        ? "nav-link active"
                        : "nav-link"
                    }
                    type="button"
                    aria-label={button.label}
                    onClick={() => setSelectedItem(button.slug)}
                  >
                    {button.label}
                  </button>
                </li>
              ))}
            </ul>
          </div>
        </div>
        {selectedItem === "about-k-youth" && (
          <div className="row g-5 mt--20">
            <div className="col-lg-6">
              <div className="accordion-style-1">
                <Accordion bsPrefix="edu-accordion" defaultActiveKey="0" flush>
                  {aboutKYouth.leftColumn.map((accordion, i) => (
                    <Accordion.Item
                      eventKey={i.toString()}
                      key={i}
                      onClick={() => toggleActive1(i.toString())}
                      bsPrefix={`edu-accordion-item ${
                        activeId1 === i.toString() ? "active-item" : ""
                      }`}
                    >
                      <div className="edu-accordion-header">
                        <CustomToggle eventKey={i.toString()}>
                          {accordion.title}
                        </CustomToggle>
                      </div>
                      <Accordion.Body bsPrefix="edu-accordion-body">
                        {accordion.body}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="accordion-style-1">
                <Accordion bsPrefix="edu-accordion" defaultActiveKey="0" flush>
                  {aboutKYouth.rightColumn.map((accordion, i) => (
                    <Accordion.Item
                      eventKey={i.toString()}
                      key={i}
                      onClick={() => toggleActive2(i.toString())}
                      bsPrefix={`edu-accordion-item ${
                        activeId2 === i.toString() ? "active-item" : ""
                      }`}
                    >
                      <div className="edu-accordion-header">
                        <CustomToggle eventKey={i.toString()}>
                          {accordion.title}
                        </CustomToggle>
                      </div>
                      <Accordion.Body bsPrefix="edu-accordion-body">
                        {accordion.body}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        )}

        {selectedItem === "about-the-course" && (
          <div className="row g-5 mt--20">
            <div className="col-lg-6">
              <div className="accordion-style-1">
                <Accordion bsPrefix="edu-accordion" defaultActiveKey="0" flush>
                  {aboutTheCourse.leftColumn.map((accordion, i) => (
                    <Accordion.Item
                      eventKey={i.toString()}
                      key={i}
                      onClick={() => toggleActive3(i.toString())}
                      bsPrefix={`edu-accordion-item ${
                        activeId3 === i.toString() ? "active-item" : ""
                      }`}
                    >
                      <div className="edu-accordion-header">
                        <CustomToggle eventKey={i.toString()}>
                          {accordion.title}
                        </CustomToggle>
                      </div>
                      <Accordion.Body bsPrefix="edu-accordion-body">
                        {accordion.body}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="accordion-style-1">
                <Accordion bsPrefix="edu-accordion" defaultActiveKey="0" flush>
                  {aboutTheCourse.rightColumn.map((accordion, i) => (
                    <Accordion.Item
                      eventKey={i.toString()}
                      key={i}
                      onClick={() => toggleActive4(i.toString())}
                      bsPrefix={`edu-accordion-item ${
                        activeId4 === i.toString() ? "active-item" : ""
                      }`}
                    >
                      <div className="edu-accordion-header">
                        <CustomToggle eventKey={i.toString()}>
                          {accordion.title}
                        </CustomToggle>
                      </div>
                      <Accordion.Body bsPrefix="edu-accordion-body">
                        {accordion.body}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        )}

        {selectedItem === "about-the-on-the-job-training" && (
          <div className="row g-5 mt--20">
            <div className="col-lg-6">
              <div className="accordion-style-1">
                <Accordion bsPrefix="edu-accordion" defaultActiveKey="0" flush>
                  {aboutTheOTJTrainig.leftColumn.map((accordion, i) => (
                    <Accordion.Item
                      eventKey={i.toString()}
                      key={i}
                      onClick={() => toggleActive5(i.toString())}
                      bsPrefix={`edu-accordion-item ${
                        activeId5 === i.toString() ? "active-item" : ""
                      }`}
                    >
                      <div className="edu-accordion-header">
                        <CustomToggle eventKey={i.toString()}>
                          {accordion.title}
                        </CustomToggle>
                      </div>
                      <Accordion.Body bsPrefix="edu-accordion-body">
                        {accordion.body}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="accordion-style-1">
                <Accordion bsPrefix="edu-accordion" defaultActiveKey="0" flush>
                  {aboutTheOTJTrainig.rightColumn.map((accordion, i) => (
                    <Accordion.Item
                      eventKey={i.toString()}
                      key={i}
                      onClick={() => toggleActive6(i.toString())}
                      bsPrefix={`edu-accordion-item ${
                        activeId6 === i.toString() ? "active-item" : ""
                      }`}
                    >
                      <div className="edu-accordion-header">
                        <CustomToggle eventKey={i.toString()}>
                          {accordion.title}
                        </CustomToggle>
                      </div>
                      <Accordion.Body bsPrefix="edu-accordion-body">
                        {accordion.body}
                      </Accordion.Body>
                    </Accordion.Item>
                  ))}
                </Accordion>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default KYouthFaq;
